var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.extras.groupIntroductionDisplay &&
    _vm.extras.groupIntroductionDisplay.display == 1
  )?_c('div',{staticClass:"m-assembly new top-nav",style:({
    background:
      _vm.extras.introBg.colorOrBg == 'color'
        ? _vm.extras.introBg.color
        : 'url(' + _vm.extras.introBg.src + ')',
  }),attrs:{"id":"introduction"}},[(_vm.extras && _vm.extras.IntroTitle.display == 1)?_c('WapTitle',{attrs:{"title":_vm.extras.IntroTitle.mainTitle || _vm.title,"en":_vm.extras.IntroTitle.subTitle || 'Introduction',"extras":_vm.extras}}):_vm._e(),(_vm.seminarInfo.descWap.length == 0 && _vm.seminarInfo.desc.length == 0)?_c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require('@/assets/images/nodata.png')}}),_c('div',{staticClass:"no-data-text"},[_vm._v("暂无数据")])]):_vm._e(),_c('div',{staticClass:"g-intrd-html",style:({
      color: _vm.extras.introductionDescription
        ? _vm.extras.introductionDescription.color
        : '',
      backgroundColor: _vm.extras.introductionDescription
        ? _vm.extras.introductionDescription.bg
        : '',
    }),domProps:{"innerHTML":_vm._s(_vm.seminarInfo.descWap ? _vm.seminarInfo.descWap : _vm.seminarInfo.desc)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }